import React, { useState } from "react";
import logo from "./Assets/Images/paybito.png";

const PaybitoInfo = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={`paybito-info${expanded ? " paybito-info--expanded" : ""}`}>
      <img
        src={logo}
        alt="logo"
        onClick={() => setExpanded((prev) => !prev)}
      />
      {expanded && (
        <p onClick={() => window.open("https://paybito.com", "_blank")}>
          Powered by PayBito instant exchange builder
        </p>
      )}
    </div>
  );
};

export default PaybitoInfo;
